import { Component, PLATFORM_ID, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ForgotPasswordService } from 'src/app/services/feature/forgot-pwd/forgot-password.service';
import { MatDialogRef } from '@angular/material/dialog';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false
})
export class ForgotPasswordComponent {
  myForm: FormGroup;
  subscription = new Subscription();
  constructor(private formBuilder: FormBuilder, private forgotPasswordService: ForgotPasswordService,
    public dialogRef: MatDialogRef<ForgotPasswordComponent>,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.myForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.myForm.valid) {
        //as by client request
        this.forgotPasswordService.sendSuccessMsg(true);
        this.subscription?.add(this.forgotPasswordService.sendEmail(this.myForm.value).subscribe((res) => {
          if (res['message'] == 'success') {
            this.forgotPasswordService.sendSuccessMsg(true);
            this.dialogRef.close(); // close here
          }
        }));
        this.myForm.reset();
      } else {
        this.dialogRef.close(); // close here
      }
    }
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
